import { Amount } from "@/components";
import { colors } from "@/styles/colors";
import { Icon } from "@/ui";
import { FunctionComponent, ReactElement } from "react";
import styles from "./View.module.scss";
import { IViewProps } from "./types";

export const View: FunctionComponent<IViewProps> = (
  props: IViewProps
): ReactElement<IViewProps> => {
  const { account, transaction, ...restProps } = props;

  return (
    <div className="historyItem" {...restProps}>
      <div>
        <div className="smallCard">
          <Icon
            backgroundColor={account ? account.color : colors.palette.black}
            className={styles.iconDefault}
            color={colors.palette.white}
            icon={account ? account.icon : ("removed-account" as any)}
            size={32}
          />
          <div className="cardContent">
            <Amount
              className="cardContentValue"
              currency={
                transaction.leftUuid === account?.uuid
                  ? transaction.rightCurrency
                  : transaction.leftCurrency
              }
              value={
                transaction.leftUuid === account?.uuid
                  ? transaction.rightAmount
                  : transaction.leftAmount
              }
            />
            <span className="cardContentLabel">
              {account?.name || "Счет удален"}
            </span>
          </div>
        </div>
      </div>
      {transaction.description && (
        <div className="historyComment">{transaction.description}</div>
      )}
    </div>
  );
};
